import { OktaAuth } from '../core';

// Export only a single object
export default OktaAuth;
